import React, { useEffect, useState } from 'react';
import api from '../api';

const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];

export default function BolLog() {
  const [bols, setBols] = useState([]);
  useEffect(() => { api.get('/api/bols').then(r => setBols(r.data || [])).catch(() => setBols([])); }, []);

  const grouped = {};
  bols.forEach(b => {
    const d = new Date(b.ship_date || b.created_at);
    const y = d.getFullYear(), m = d.getMonth();
    grouped[y] = grouped[y] || {};
    grouped[y][m] = grouped[y][m] || [];
    grouped[y][m].push(b);
  });

  const years = Object.keys(grouped).sort((a, b) => b - a);

  return (
    <div>
      <h2>BOL Log</h2>
      {years.length === 0 && <div className="card">No BOLs yet.</div>}
      {years.map(y => (
        <div key={y}>
          <h3>{y}</h3>
          {Object.keys(grouped[y]).sort((a, b) => b - a).map(m => (
            <div key={m} style={{ marginBottom: 16 }}>
              <h4 style={{ color: '#1a3a5c', margin: '8px 0' }}>{MONTHS[m]}</h4>
              <div className="card" style={{ padding: 0 }}>
                <table>
                  <thead><tr><th>Date</th><th>BOL #</th><th>Customer</th><th>Items</th><th>Total Units</th><th>Skids</th><th>Carrier</th></tr></thead>
                  <tbody>
                    {grouped[y][m].map(b => (
                      <tr key={b.id}>
                        <td><span className="badge" style={{ background: '#e8f0fe', color: '#1a73e8' }}>{(b.ship_date || '').slice(0, 10)}</span></td>
                        <td>{b.bol_number}</td>
                        <td>{b.customer_name}</td>
                        <td>{b.item_count || (b.items ? b.items.length : 0)}</td>
                        <td>{b.total_units || 0}</td>
                        <td>{b.total_skids || 0}</td>
                        <td>{b.carrier}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
